<template>
  <el-card shadow="never" class="admin-search-card admin-card admin-card--search">
    <el-form class="hc-search" @submit.prevent="SubmitEvent">
      <el-form-item
        class="item_list"
        :label="resolveSearchLabel(item)"
        v-for="(item, index) in data"
        :key="index"
      >
        <div v-if="item.type == 'input'">
          <el-input
            v-model="item.value"
            :placeholder="resolveSearchPlaceholder(item)"
            clearable
          />
        </div>
        <div v-if="item.type == 'select'">
          <el-select
            :placeholder="item.placeholder ?? t('pleaseSelect')"
            v-model="item.value"
            style="width: 200px"
            filterable
            :clearable="item.clearable ?? true"
          >
            <el-option
              v-for="(obj, i) in item.children"
              :key="i"
              :label="obj.label"
              :value="obj.value"
            />
          </el-select>
        </div>

        <div class="timer" v-if="item.type == 'daterange'">
          <el-date-picker
            v-model="item.value"
            type="daterange"
            value-format="YYYY-MM-DD"
            :start-placeholder="t('startTime')"
            :end-placeholder="t('endTime')"
          />
        </div>
        <div class="timer" v-if="item.type == 'month'">
          <el-date-picker
            v-model="item.value"
            type="month"
            value-format="YYYY-MM"
            :placeholder="t('selectMonth')"
          />
        </div>
        <div
          v-if="props.data.length - 1 == index"
          class="search-actions"
        >
          <el-button class="btn" type="primary" native-type="submit">{{ t('search') }}</el-button>
          <el-button class="btn" @click="clear">{{ t('reset') }}</el-button>
          <slot name="btns"></slot>
        </div>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { t } from "@/locale/index.js";
import { resolveSearchLabel, resolveSearchPlaceholder } from "@/locale/fields.js";

const emit = defineEmits();
const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
});

const SubmitEvent = () => {
  emit("serch", props.data);
};

const clear = () => {
  props.data.forEach((item) => {
    item.value = item.defaultValue ?? '';
  });
  emit("serch", props.data);
};
</script>

<style lang="less" scoped>
.admin-search-card {
  :deep(.el-card__body) {
    padding: 12px 16px 4px;
  }
}

.hc-search {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.item_list {
  min-width: 200px;
  margin-right: 16px;
  margin-bottom: 8px;
  font-size: 14px;
}

.timer {
  display: flex;
}

.search-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 4px;
}
</style>
